__turbopack_context__.v({
  "className": "dm_mono_9bffbd53-module__Mpur-q__className",
  "variable": "dm_mono_9bffbd53-module__Mpur-q__variable",
});
